import axios from 'axios';
import { BULK_SCENARIO_GROUP_REQUEST,
         BULK_SCENARIO_GROUP_SUCCESS,
         BULK_SCENARIO_GROUP_ERROR,
         BULK_SCENARIO_GROUP_UPDATE_TASK } from '../../constants/bulkScenarioGroup/bulkScenarioGroupConstants';
import { FETCH_SCENARIO_INFORMATION } from '../../constants/bulkScenarioGroup/bulkScenarioInfoConstants';

export const getScenarioGroupDetails = () => (dispatch) => {
    try {
        dispatch({type: BULK_SCENARIO_GROUP_REQUEST})

        const url = '/close_loop/fetch/base_scenario_info';
        axios.get(url).then((response) => {
            if(response.status === 200) {
                const { data } = response.data
                dispatch({type: BULK_SCENARIO_GROUP_SUCCESS, payload: data})
            }
        })

    } catch(error) {
        console.log(error);
        dispatch({type: BULK_SCENARIO_GROUP_ERROR, error: error.message});
    }
}


export const updateScenarioGroupDetails = (data) => (dispatch) => {
    dispatch({type: BULK_SCENARIO_GROUP_UPDATE_TASK, payload: data})
}


export const fetchScenarioInformation = (data) => (dispatch) => {
    dispatch({type: FETCH_SCENARIO_INFORMATION ,payload: data})
}